import React, { useRef } from "react";
import { Link } from "react-router-dom";
import "./hotel-detail.scss";
import { FaHeart } from "react-icons/fa";
import { MdPhotoLibrary } from "react-icons/md";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";

const HotelDetailSection = () => {
  const images = [
    "/images/backgrounds/room-1.png",
    "/images/hotels/hotel-2.svg",
    "/images/hotels/hotel-1.svg",
    "/images/backgrounds/room-1.png",
    "/images/hotels/hotel-4.svg",
    "/images/backgrounds/room-1.png",
    "/images/hotels/hotel-4.svg",
    "/images/backgrounds/room-1.png",
  ];

  const previewCount = 7;
  const previewImages = images.slice(0, previewCount);
  const remainingCount = images.length - previewCount;

  const firstImgRef = useRef();

  return (
    <>
      <section className="hotel-detail-section">
        <div className="download-ticket">
          <Link>
            {" "}
            <img src="/images/icons/ticket.svg" alt="icon" /> Download Reciept
          </Link>
        </div>

        <div className="overview-content">
          <div className="avail-content-box" id="overview-content">
            <div className="overview-info">
              <div className="title-wrap">
                <h2>
                  The City Lodge
                  <div className="stars">
                    <img src="/images/icons/star.svg" alt="star" />
                    <img src="/images/icons/star.svg" alt="star" />
                    <img src="/images/icons/star.svg" alt="star" />
                    <img src="/images/icons/star.svg" alt="star" />
                    <img src="/images/icons/star.svg" alt="star" />
                  </div>
                </h2>
                <div className="desc">
                  <p>
                    <img src="/images/icons/map-icon.svg" alt="map" /> House 19
                    Street 67, G-6/4 G 6/4, G-6, Islamabad, Islamabad Capital
                    Territory 44000, Pakistan
                  </p>
                  <Link to="">Show on Map</Link>
                </div>
              </div>
            </div>
            <PhotoProvider>
              <div className="gallery-wrap">
                <div className="row g-1">
                  <div className="col-lg-4">
                    <div className="img-wrapper h-100">
                      <PhotoView src={images[0]}>
                        <img
                          ref={firstImgRef}
                          src={images[0]}
                          className="img-fluid main-img h-100 w-100"
                          alt="Main Room"
                          style={{ cursor: "pointer" }}
                        />
                      </PhotoView>
                    </div>
                  </div>

                  <div className="col-lg-8">
                    <div className="row g-1">
                      {previewImages.slice(1).map((src, idx) => {
                        const isLast =
                          idx === previewImages.slice(1).length - 1;
                        return (
                          <div className="col-6 col-md-4" key={idx + 1}>
                            <div className="img-wrapper">
                              <PhotoView src={src}>
                                <img
                                  src={src}
                                  className="img-fluid sub-img"
                                  alt={`Sub Image ${idx + 1}`}
                                  style={{ cursor: "pointer" }}
                                />
                              </PhotoView>

                              {idx === 0 && (
                                <div className="wishlist-icon">
                                  <FaHeart color="lightgrey" />
                                </div>
                              )}

                              {isLast && remainingCount > 0 && (
                                <div
                                  className="see-more-overlay"
                                  onClick={() => firstImgRef.current.click()}
                                  style={{ cursor: "pointer" }}
                                >
                                  <MdPhotoLibrary color="white" />
                                  <span>See All {images.length} Photos</span>
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                {/* Hidden PhotoViews to support lightbox navigation */}
                {images.slice(previewCount).map((src, idx) => (
                  <PhotoView src={src} key={`hidden-${idx}`}>
                    <div style={{ display: "none" }} />
                  </PhotoView>
                ))}
              </div>
            </PhotoProvider>
          </div>

          <div className="avail-content-box" id="amenities">
            <div className="row g-3">
              <div className="col-lg-8">
                <div className="amenities-wrap">
                  <div className="item-box">
                    <h5>Amenities</h5>
                    <div className="amenities-list">
                      <div className="amenity-item">
                        <img src="/images/icons/parking-icon.svg" alt="icon" />
                        <span>
                          Private parking{" "}
                          <small className="highlight">Free</small>
                        </span>
                      </div>
                      <div className="amenity-item">
                        <img
                          src="/images/icons/frontdesk-icon.svg"
                          alt="icon"
                        />
                        <span>24-hour front desk</span>
                      </div>
                      <div className="amenity-item">
                        <img src="/images/icons/luggage-icon.svg" alt="icon" />
                        <span>Luggage storage</span>
                      </div>
                      <div className="amenity-item">
                        <img src="/images/icons/car-rent-icon.svg" alt="icon" />
                        <span>Car rentals</span>
                      </div>
                      <div className="amenity-item">
                        <img src="/images/icons/currency-icon.svg" alt="icon" />
                        <span>Currency exchange</span>
                      </div>
                      <div className="amenity-item">
                        <img src="/images/icons/wakeup-icon.svg" alt="icon" />
                        <span>Wake-up call</span>
                      </div>
                    </div>
                    <Link className="show-more-link" to="#">
                      All Amenities
                    </Link>
                  </div>

                  <div className="item-box">
                    <h5>Property Description</h5>
                    <p className="description-text">
                      With a stay at The City Lodge in Islamabad (G-6 Sector),
                      you'll be a 4-minute drive from Supreme Court of Pakistan
                      and 6 minutes from Allama Iqbal Open University. This
                      guesthouse is 2.3 mi (3.7 km) from Embassy of the United
                      States of America and 3.5 mi (5.6 km) from Margalla Hills
                      National Park.
                    </p>
                    <Link className="show-more-link" to="#">
                      Show More
                    </Link>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="rating-box">
                  <div className="rating-score">
                    <span className="score-box">
                      8.9 <span>/10</span>{" "}
                    </span>
                  </div>
                  <ul className="score-details">
                    <li>Convenience 7</li>
                    <li>Amenities 7</li>
                    <li>Location 7</li>
                    <li>Service 7</li>
                  </ul>
                  <Link className="show-more-link" to="#">
                    All 11 Reviews
                  </Link>
                </div>

                <div className="surroundings-box">
                  <h6>
                    {" "}
                    <img src="/images/icons/srrounding.svg" alt="icon" />{" "}
                    Surroundings
                  </h6>
                  <div className="surrounding-item">
                    <img src="/images/icons/train-icon.svg" alt="icon" />
                    <span>Train: Islamabad Railway Station (1.03 km)</span>
                  </div>
                  <div className="surrounding-item">
                    <img src="/images/icons/train-icon.svg" alt="icon" />
                    <span>Train: Rawalpindi Station (8.1 km)</span>
                  </div>
                  <Link className="show-more-link" to="#">
                    View on Map
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <ul className="includings">
            <li>
              {" "}
              <img src="/images/icons/utensils.svg" alt="utensils" />
              Breakfast included (3)
            </li>
            <li>Prepay Online (3)</li>
            <li>Instant Confirmation (3)</li>
          </ul>
        </div>
      </section>
    </>
  );
};

export default HotelDetailSection;
